export default function append(first, second) {
  first.push.apply(first, second);
  return first;
}